import {
  filterSchema,
  groupBySchema,
  idSchema,
  LIMITS,
  sortSchema,
  taskKeySchema,
  UNASSIGNED,
} from '@wednesday/contracts';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { boardQueryOptions } from '@/features/board/api';
import { projectQueryOptions } from '@/features/projects/api';
import { ProjectPage } from '@/features/projects/project-page';

export const Route = createFileRoute('/_app/projects/$projectId')({
  // The toolbar lives in the URL so a filtered board can be shared (TLB-7). Anything malformed is
  // dropped instead of breaking the page.
  validateSearch: z.object({
    /** The task whose card is open (TSK-10, CRD-1). */
    task: taskKeySchema.optional().catch(undefined),
    /** The card's tab when not Updates, e.g. Files from the Files cell (D43). */
    tab: z.enum(['files', 'activity']).optional().catch(undefined),
    q: z.string().max(LIMITS.searchQueryMax).optional().catch(undefined),
    people: z
      .array(z.union([idSchema, z.literal(UNASSIGNED)]))
      .max(100)
      .optional()
      .catch(undefined),
    filter: filterSchema.optional().catch(undefined),
    sort: sortSchema.optional().catch(undefined),
    groupBy: groupBySchema.optional().catch(undefined),
    /** Table (default) or Kanban (KAN-1). */
    view: z.enum(['table', 'kanban']).optional().catch(undefined),
  }),
  loader: ({ context, params }) =>
    Promise.all([
      context.queryClient.query({ ...projectQueryOptions(params.projectId), staleTime: 0 }),
      context.queryClient.query({ ...boardQueryOptions(params.projectId), staleTime: 0 }),
    ]),
  component: ProjectPage,
});
